import styled from 'styled-components';

export const Container = styled.div`
  overflow: hidden;
  transition: 0.25s ease;
  transition-duration: 0.25s;
`;
